import axios from "axios";


// deploy pif http://981e7478-2274-4910-a841-2e6e38cfd341.pub.instances.scw.cloud/api
// deploy fitaca http://12736ea4-0e4f-425b-be87-8898a000599b.pub.instances.scw.cloud/api
// https://a1e34f34-fd6c-4bf7-b8b3-4528eeb499e6.pub.instances.scw.cloud/api



const API_URL = "https://a1e34f34-fd6c-4bf7-b8b3-4528eeb499e6.pub.instances.scw.cloud/api";
//const API_URL = "http://localhost:8080/api";
// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_API_URL + "auth/",
// });

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "/auth/signin", { username, password })
      .then((response) => {
        if (response.data.accessToken) {
          localStorage.setItem("user", JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password, nome, cognome, sede, roles) {
    console.log(username, cognome);
    return axios.post(API_URL + "/auth/signup", {
      username,
      email,
      password,
      nome,
      cognome,
      sede,
      roles
    });
  }
}

export default new AuthService();
